module.exports = __webpack_public_path__ + "img/esg-logo.300dd360.jpg";